module.exports = __webpack_public_path__ + "img/data-bg.fbb8535c.png";